import { RoomList } from '../components/RoomSelector/RoomSelector.types';
import getPreferredRoomListsService from 'owa-calendar-scheduling-service/lib/services/getPreferredRoomListsService';
import { isSuccessStatusCode } from 'owa-http-status-codes';

export default function getPreferredRoomLists(): Promise<RoomList[]> {
    return getPreferredRoomListsService().then(response => {
        if (isSuccessStatusCode(response.status)) {
            return response.json().then(preferredRoomLists => {
                if (preferredRoomLists && preferredRoomLists.length !== 0) {
                    return preferredRoomLists.map(result => ({
                        name: result.Name,
                        email: result.EmailAddress,
                    }));
                }
                return [];
            });
        }
        return [];
    });
}
